import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'
import z from 'zod/v3'
import { withRoutePermissions } from '~/utils/rbac'
import { AddProductPage1 } from '../../../components/routes/products/AddProductPage1'
import { AddProductPage2 } from '../../../components/routes/products/AddProductPage2'
import { AddProductPage3 } from '../../../components/routes/products/AddProductPage3'
import { AddProductPage4 } from '../../../components/routes/products/AddProductPage4'
import ProductsOutletProvider from '../../../components/routes/products/ProductsOutletProvider'
export const stepsSchema = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])

export type Step = z.infer<typeof stepsSchema>

export const Route = createFileRoute('/_authenticated/products/new')({
  staticData: {
    permission: ['add', 'products.products.product'],
  },
  component: CreateProductStepPage,
  validateSearch: z.object({ step: stepsSchema.optional() }),
})
withRoutePermissions(Route)

const stepComponents = {
  1: AddProductPage1,
  2: AddProductPage2,
  3: AddProductPage3,
  4: AddProductPage4,
} satisfies Record<Step, () => JSX.Element>

function CreateProductStepPage() {
  const { step = 1 } = Route.useSearch()

  const Component = stepComponents[step]

  return (
    <ProductsOutletProvider productId={undefined}>
      <Component />
    </ProductsOutletProvider>
  )
}
